const keys = [
  'Overview',
  'eCOC Templates',
  'Jobs',
  'Supplies',
  'Invoices',
  'Prepaid',
];

const vals = [
  '/',
  '/templates',
  '/jobs',
  '/supplies',
  '/invoices',
  '/prepaidrequest',
];

const tabs = {};
for (let i = 0; i < keys.length; i += 1) {
  tabs[keys[i]] = vals[i];
}

const manageAccess = {
  keys: ['Current Users', 'Create User', 'Inactive Users'],
  vals: [
    '/manage-access/current-users',
    '/manage-access/create-user',
    '/manage-access/inactive-users',
  ],
};

manageAccess.tabs = manageAccess.keys.reduce((acc, key, i) => {
  acc[key] = manageAccess.vals[i];
  return acc;
}, {});

export default {
  keys,
  tabs,
  vals,
  manageAccess,
};



// WEBPACK FOOTER //
// ./src/constants/tabs.js